"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentTypeToIconUrl = exports.ContentTypeToIconName = exports.ContentType = void 0;
var ContentType;
(function (ContentType) {
    ContentType["course"] = "course";
    ContentType["lesson"] = "lesson";
    ContentType["videoTutorial"] = "videoTutorial";
    ContentType["learningPath"] = "learningPath";
    ContentType["skillTree"] = "skillTree";
    ContentType["path"] = "path";
    ContentType["challenge"] = "challenge";
    ContentType["assessment"] = "assessment";
    ContentType["systemAssessment"] = "systemAssessment";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
exports.ContentTypeToIconName = (_a = {},
    _a[ContentType.lesson] = 'lessonIconLearningPanel',
    _a[ContentType.course] = 'courseIconLearningPanel',
    _a[ContentType.challenge] = 'challengeIconLearningPanel',
    _a[ContentType.videoTutorial] = 'videoLearningPanel',
    _a[ContentType.skillTree] = 'skillTree',
    _a[ContentType.learningPath] = 'path',
    _a[ContentType.path] = 'path',
    _a[ContentType.assessment] = 'assessment',
    _a[ContentType.systemAssessment] = 'assessment',
    _a);
var PUBLIC_URL = process.env.PUBLIC_URL;
exports.ContentTypeToIconUrl = (_b = {},
    _b[ContentType.lesson] = "".concat(PUBLIC_URL, "/images/lessonDefaultCard.svg"),
    _b[ContentType.course] = "".concat(PUBLIC_URL, "/images/courseDefaultCard.svg"),
    _b[ContentType.challenge] = "".concat(PUBLIC_URL, "/images/challengeBackground.svg"),
    _b[ContentType.videoTutorial] = "".concat(PUBLIC_URL, "/images/videoDefaultCard.svg"),
    _b[ContentType.skillTree] = "".concat(PUBLIC_URL, "/images/skillTreeBackground.webp"),
    _b[ContentType.learningPath] = "".concat(PUBLIC_URL, "/images/learningPathCard.svg"),
    _b[ContentType.path] = "".concat(PUBLIC_URL, "/images/learningPathCard.svg"),
    _b[ContentType.assessment] = "".concat(PUBLIC_URL, "/images/assessment.svg"),
    _b[ContentType.systemAssessment] = "".concat(PUBLIC_URL, "/images/assessment.svg"),
    _b);
